import { makeStyles } from 'tss-react/mui'

export const useCommonStyles = makeStyles()(theme => ({
  shrink: {
    transform: 'translate(0px, -2px) scale(0.75)',
  },
  actionColumn: {
    padding: theme.spacing(2),
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
  },
}))
